import { idaasConfig } from "../constants/idaas_config"
import http from "../utils/http"
import api from "../utils/api"
import { convertUrl } from "../helpers/helper"
export interface GetOAuthTokenResponse {
  access_token: string
  expires_in: number
  id_token: string
  refresh_token: string
  scope: string
  token_type: string
}

export interface ErrorResponse {
  Status: {
    Code: number
    Type: string
  }
}

interface Response {
  Response?: GetOAuthTokenResponse
  Status?: ErrorResponse
}

const getHeaderAccessToken = async (token: string): Promise<Response> => {
  const response = await http.post(
    idaasConfig.token_endpoint,
    `${idaasConfig.token_request_body()}&code=${token}`,
    token,
    { "Content-type": "application/x-www-form-urlencoded" }
  )
  const modifiedResponse = {
    Status: response.Status ? response : undefined,
    Response: response.access_token ? response : undefined,
  }
  return modifiedResponse
}

//Generate Taas APIM token//
const getHeaderTaasToken = async (token: string): Promise<any> => {
    try {
   const response = await fetch(convertUrl(`getTassTokenInfo`), {
      method: 'GET',
      headers: {
        "Content-type": "application/x-www-form-urlencoded",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`,
        "x-gravitee-api-key": `${api[api.env].apiKey}`,
      },
      // body: `grant_type=${type}`,
    });

    // Check if the response is ok (status 2xx)
    if (!response.ok) {
      throw new Error("Failed to fetch Bau Taas Token");
    }

    const data = await response.json(); // Parse the response body to JSON

    const modifiedResponse = {
      Status: data.Status ? data : undefined, 
      Response: data.access_token ? data : undefined,
    };
    return data;

  } catch (error) {
    console.error("Error fetching Taas token:", error);
    throw error;
  }
}
//Generate BAU APIM token//
const getBauAccessToken = async (token: string): Promise<any> => {
  try {
   const response = await fetch(convertUrl(`getBauTokenInfo`), {
      method: 'GET',
      headers: {
        "Content-type": "application/x-www-form-urlencoded",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`,
        "x-gravitee-api-key": `${api[api.env].apiKey}`,
      },
      // body: `grant_type=${type}`,
    });

    // Check if the response is ok (status 2xx)
    if (!response.ok) {
      throw new Error("Failed to fetch Bau Taas Token");
    }

    const data = await response.json(); // Parse the response body to JSON

    const modifiedResponse = {
      Status: data.Status ? data : undefined, 
      Response: data.access_token ? data : undefined,
    };
    return data;

  } catch (error) {
    console.error("Error fetching Taas token:", error);
    throw error;
  }
}

const getUserDetails = async (token: string): Promise<any> => {

  try {
    
    const response = await http.get(`getUserInfo`, token);

    // Check if the response is ok (status 2xx)
    //const data = await response.json(); // Parse the response body to JSON
    const password = "m5zQi5Vu3mI8sFsgLTH91Zaw3b8a"; // Same password used for encryption
    //const password = "simplekey";  // Same key used for encryption
  
    // Replace with your actual Base64 encrypted data from encryption
    const base64EncryptedData = response.encryptedData;  // Example Base64 encrypted data
  
    // Decrypt the data from Base64
    const decryptedResponse = decryptData(base64EncryptedData, password);

  return decryptedResponse;
  } catch (error) {
    console.error("Error fetching User Info:", error);
    throw error;
  }
}

const loginApi = async (token: string) => {
  const response = await http.post(
    idaasConfig.token_endpoint,
    `${idaasConfig.token_request_body()}&code=${token}`,
    token,
    null
  )
}
function xorEncryptDecrypt(input:any, key:any) {
  const inputArray = new TextEncoder().encode(input);
  const keyArray = new TextEncoder().encode(key);

  let resultArray = new Uint8Array(inputArray.length);
  for (let i = 0; i < inputArray.length; i++) {
    resultArray[i] = inputArray[i] ^ keyArray[i % keyArray.length];
  }

  // Convert result back to string
  return new TextDecoder().decode(resultArray);
}

function decryptData(encryptedData:any, key:any) {
  const decodedData = atob(encryptedData);  // Decode Base64
  return xorEncryptDecrypt(decodedData, key);
}
export { getHeaderAccessToken, loginApi, getHeaderTaasToken, getUserDetails, getBauAccessToken }
